import { type ComponentGroupAutocompleteOption } from "@src/pages/compatibilityCheck/components/usageList/toolbar/Toolbar.utils";
import * as Yup from "yup";

export interface ToolbarFormState {
    componentGroup?: Partial<ComponentGroupAutocompleteOption> | null;
    modelArticleNumber?: string | null;
    modelName?: string | null;
    modelSpecification?: string | null;
    modelYear?: string | null;
}

export const defaultToolbarFormState: ToolbarFormState = {
    modelArticleNumber: null,
    modelName: null,
    componentGroup: null,
    modelSpecification: null,
    modelYear: null,
};

export interface SessionFilterState {
    articleDescription?: string | null;
    articleNumber?: string | null;
    componentGroup?: string | null;
    modelSpecification?: string | null;
    modelYear?: string | null;
}

export const defaultSessionFilterState: SessionFilterState = {
    articleNumber: null,
    articleDescription: null,
    componentGroup: null,
    modelSpecification: null,
    modelYear: null,
};

export const sessionFilterSchema: Yup.Schema<SessionFilterState> = Yup.object({
    articleNumber: Yup.string().nullable(),
    articleDescription: Yup.string().nullable(),
    componentGroup: Yup.string().nullable(),
    modelSpecification: Yup.string().nullable(),
    modelYear: Yup.string().nullable(),
});
